// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gestion-comptes {
  margin: 0 auto;
  width: 100%;
}

.gestion-comptes h1 {
  margin-bottom: 3rem;
}

/* Style spécifique pour assurer que le menu d'actions est correctement positionné */
.action-menu-container {
  position: relative;
  display: inline-block;
}

.action-options-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  min-width: 220px;
  z-index: 1000;
  padding: 5px 0;
  margin-top: 5px;
}

.user-name,
.user-email,
.commande-count,
.commande-value,
.user-role,
.creation-date {
  font-size: 1.4rem;
  color: #2c3948;
}

.user-role {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  color: #2c3948;
  cursor: pointer;
}

.user-role span {
  text-decoration: underline;
}

.user-role .edit-icon {
  width: 1.6rem;
  height: 1.6rem;
  color: #f97316;
}

.user-role:hover span {
  color: #f97316;
}

.user-role:hover .edit-icon {
  color: #c4631f;
}

/* Style pour la colonne Type */
.type-cell {
  font-size: 1.4rem;
  color: #2c3948;
}

.gestion-comptes-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}

/* Styles pour le modal de changement de rôle */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.change-role-modal {
  background-color: #fffdfc;
  /* padding: 2rem; */
  border-radius: 0.8rem;
  min-width: 40rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.change-role-modal h2 {
  margin-bottom: 1rem;
}

.change-role-modal p {
  margin-bottom: 2rem;
  color: #6b7280;
}

.role-options {
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
}

.role-button {
  padding: 0.8rem 1.6rem;
  border-radius: 0.4rem;
  border: 1px solid #e5e7eb;
  background-color: #fffdfc;
  cursor: pointer;
  font-size: 1.4rem;
  transition: all 0.2s ease;
}

.role-button:hover {
  background-color: #f9fafb;
}

.role-button.active {
  background-color: rgba(215, 217, 217, 0.2);
  border-color: #dbeafe;
  color: #484848;
}

.role-button.selected {
  background-color: #fcf1e7;
  border-color: #f97316;
  color: #f97316;
  box-shadow: 0 0 0 1px #f97316;
}

.role-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
}

/* Style pour l'info-bulle du bouton "Créer un utilisateur" */
.button-with-tooltip[title]:hover::after {
  content: attr(title);
  position: absolute;
  bottom: 100%;
  right: 0;
  background-color: #2c3948;
  color: white;
  padding: 0.8rem 1.2rem;
  border-radius: 0.4rem;
  font-size: 1.2rem;
  white-space: nowrap;
  z-index: 1000;
  margin-bottom: 0.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  max-width: 30rem;
  white-space: normal;
  text-align: center;
}

.button-with-tooltip[title]:hover::before {
  content: "";
  position: absolute;
  bottom: 100%;
  right: 2rem;
  border: 0.5rem solid transparent;
  border-top-color: #2c3948;
  margin-bottom: -0.5rem;
}

/* Styles pour les colonnes de lots techniques et départements */
.lots-techniques,
.lots-departements {
  font-size: 1.3rem;
  line-height: 1.6;
  color: #2c3948;
}

.lots-techniques span,
.lots-departements span {
  display: block;
  margin: 0.2rem 0;
}

.no-lot {
  color: #9ca3af;
  font-style: italic;
}

/* Styles pour la modal de réattribution */
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem 2rem 1rem 2rem;
  border-bottom: 1px solid #e5e7eb;
}

.modal-header h2 {
  margin: 0;
  font-size: 1.8rem;
  color: #2c3948;
}

.close-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
  transition: color 0.2s ease;
}

.close-button:hover {
  color: #f97316;
}

.close-button svg {
  width: 2rem;
  height: 2rem;
}

.modal-body {
  padding: 2rem;
}

.info-section {
  background-color: rgba(194, 194, 194, 0.46);
  border-radius: 0.6rem;
  padding: 1.5rem;
  margin-bottom: 2rem;
}

.info-row {
  display: flex;
  padding: 0.5rem 0;
}

.info-row:not(:last-child) {
  border-bottom: 1px solid #e5e7eb;
}

.info-label {
  font-weight: 600;
  color: #6b7280;
  min-width: 180px;
  font-size: 1.4rem;
}

.info-value {
  color: #2c3948;
  font-size: 1.4rem;
}

.form-group-modal {
  margin-top: 1.5rem;
}

.form-group-modal label {
  display: block;
  margin-bottom: 0.8rem;
  font-weight: 600;
  color: #2c3948;
  font-size: 1.4rem;
}

.form-select {
  width: 100%;
  padding: 1rem;
  border-radius: 0.6rem;
  border: 1px solid #d1d5db;
  font-size: 1.4rem;
  color: #2c3948;
  background-color: white;
  cursor: pointer;
  transition: border-color 0.2s ease;
}

.form-select:hover {
  border-color: #f97316;
}

.form-select:focus {
  outline: none;
  border-color: #f97316;
  box-shadow: 0 0 0 3px rgba(218, 112, 39, 0.1);
}

.modal-actions {
  padding: 1rem 2rem 2rem 2rem;
  border-top: 1px solid #e5e7eb;
}

.actions-cell {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.modal-container {
  background-color: #fff;
  border-radius: 8px;
  max-width: 600px;
  width: 90%;
}

/* ═══════════════════════════════════════════════════════
   Cartes membres acheteurs — style identique aux membres prestataires
   Basculer ACHETEURS_VIEW_MODE 'cards' | 'table' dans GestionComptes.tsx
   ═══════════════════════════════════════════════════════ */

/* ── Grille ── */
.gc-membres-cards-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.4rem;
  padding: 0.5rem 0 1rem;
}

@media (min-width: 1600px) {
  .gc-membres-cards-grid {
    grid-template-columns: repeat(6, 1fr);
  }
}

@media (max-width: 1100px) {
  .gc-membres-cards-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .gc-membres-cards-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 480px) {
  .gc-membres-cards-grid {
    grid-template-columns: 1fr;
  }
}

.gc-membres-cards-empty {
  color: #9ca3af;
  font-style: italic;
  font-size: 1.3rem;
  padding: 2rem 0;
  text-align: center;
}

/* ── Carte ── */
.gc-membre-card {
  background: #fff;
  border-radius: 12px;
  overflow: visible;
  position: relative;
  min-width: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  transition:
    box-shadow 0.2s,
    transform 0.2s;
  cursor: default;
}

.gc-membre-card--editable {
  cursor: pointer;
}

.gc-membre-card--editable:hover {
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.14);
  transform: translateY(-2px);
}

.gc-membre-card-inner {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  border-radius: inherit;
  overflow: hidden;
  position: relative;
}

/* ── Bandeau gris ── */
.gc-membre-card-header {
  height: 72px;
  border-radius: 12px 12px 0 0;
  position: relative;
  overflow: visible;
}

.gc-membre-card-banner {
  width: 100%;
  height: 72px;
  background: #e5e7eb;
  border-radius: 12px 12px 0 0;
}

/* ── Badge rôle top-right ── */
.gc-membre-card-role-badge {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  padding: 0.25rem 0.6rem;
  border-radius: 20px;
  font-size: 1rem;
  font-weight: 700;
  background: rgba(107, 114, 128, 0.88);
  color: #fff;
  z-index: 2;
  white-space: nowrap;
  max-width: calc(100% - 1rem);
  overflow: hidden;
  text-overflow: ellipsis;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.18);
}

.gc-membre-card-role-badge--admin {
  background: #f97316;
  box-shadow: 0 1px 4px rgba(249, 115, 22, 0.35);
}

/* Couleurs alignees sur l'annuaire : signataires/admin = orange (titulaire),
   simples = gris (prestataire libre). Bandeau + pastille. Ombre SOMBRE (comme l'annuaire)
   pour que la pastille ne se fonde pas dans un bandeau de la meme couleur. */
.gc-membre-card--titulaire .gc-membre-card-banner {
  background: #f97316;
}
.gc-membre-card--titulaire .gc-membre-card-role-badge {
  background: #f97316;
  color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
}
.gc-membre-card--libre .gc-membre-card-banner {
  background: #d1d5db;
}
.gc-membre-card--libre .gc-membre-card-role-badge {
  background: #d1d5db;
  color: #374151;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
}

/* ── Avatar rond chevauchant le bandeau ── */
.gc-membre-card-avatar-wrapper {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 30px;
  width: 64px;
  height: 64px;
  background: #fff;
  border-radius: 50%;
  border: 1.5px solid #d1d5db;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 1;
  overflow: hidden;
}

.gc-membre-card-avatar {
  width: 100%;
  height: 100%;
  background: #f3f4f6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.6rem;
  font-weight: 700;
  color: #6b7280;
  letter-spacing: 0.05em;
}

/* ── Corps ── */
.gc-membre-card-body {
  padding: 4rem 1.2rem 1.4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.2rem;
  flex: 1 1;
  text-align: center;
}

.gc-membre-card-name {
  font-weight: 700;
  font-size: 1.35rem;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  margin: 0;
}

.gc-membre-card-fonction {
  font-size: 1.25rem;
  color: #374151;
  font-style: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  margin: 0;
}

/* ── Contacts ── */
.gc-membre-card-contacts {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.1rem;
  margin-top: 0.5rem;
  width: 100%;
}

.gc-membre-card-contact {
  font-size: 1.2rem;
  color: #6b7280;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  display: block;
}

.gc-membre-card-email {
  font-size: 1.2rem;
}

.gc-membre-card-hint {
  font-size: 1.05rem;
  color: #9ca3af;
  font-style: italic;
  margin: 0.6rem 0 0;
  text-align: center;
}

/* ── Footer date + MDP ── */
.gc-membre-card-footer {
  border-top: 1px solid #f3f4f6;
  padding: 0.65rem 1rem;
  min-height: 4rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.gc-membre-card-date {
  font-size: 1rem;
  color: #9ca3af;
  font-style: italic;
}

.gc-membre-card-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.35rem 1rem;
  border-radius: 20px;
  border: 1px solid #e5e7eb;
  background: #f9fafb;
  color: #6b7280;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition:
    background 0.15s,
    border-color 0.15s;
}

.gc-membre-card-btn:hover {
  background: #f3f4f6;
  border-color: #d1d5db;
}

.gc-membre-card-btn svg {
  width: 13px;
  height: 13px;
}

/* ── Skeleton ── */
@keyframes gc-membre-shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

.gc-membre-card-skeleton {
  pointer-events: none;
}

.gc-membre-card-skeleton .sk {
  background: linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 50%, #e5e7eb 75%);
  background-size: 200% 100%;
  animation: gc-membre-shimmer 1.4s ease-in-out infinite;
  border-radius: 4px;
  display: block;
}

.gc-membre-card-skeleton .sk-banner {
  border-radius: 12px 12px 0 0;
  height: 72px;
}

.gc-membre-card-skeleton .sk-badge {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  width: 70px;
  height: 18px;
  border-radius: 20px;
  z-index: 2;
  background: linear-gradient(90deg, #d1d5db 25%, #e5e7eb 50%, #d1d5db 75%);
  background-size: 200% 100%;
  animation: gc-membre-shimmer 1.4s ease-in-out infinite;
  display: block;
}

.gc-membre-card-skeleton .sk-avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
}

.gc-membre-card-skeleton .sk-line {
  height: 11px;
  margin: 0 auto;
}

.gc-membre-card-skeleton .sk-line--name {
  width: 72%;
  margin-bottom: 4px;
}

.gc-membre-card-skeleton .sk-line--fonction {
  width: 52%;
  margin-bottom: 6px;
}

.gc-membre-card-skeleton .sk-line--contact {
  width: 85%;
  margin-bottom: 3px;
}
`, "",{"version":3,"sources":["webpack://./src/composants/GestionComptes/GestionComptes.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oFAAoF;AACpF;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;;;;;;EAME,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,+CAA+C;AAC/C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA,6DAA6D;AAC7D;EACE,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,qBAAqB;EACrB,yCAAyC;EACzC,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,gCAAgC;EAChC,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,gEAAgE;AAChE;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2CAA2C;EAC3C,qBAAqB;EACrB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;;4DAG4D;;AAE5D,iBAAiB;AACjB;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB;;kBAEgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;;6EAE6E;AAC7E;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,yCAAyC;AAC3C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,yCAAyC;AAC3C;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;EACxC,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;EACX,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf;;sBAEoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yEAAyE;EACzE,0BAA0B;EAC1B,sDAAsD;EACtD,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,yEAAyE;EACzE,0BAA0B;EAC1B,sDAAsD;EACtD,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB","sourcesContent":[".gestion-comptes {\r\n  margin: 0 auto;\r\n  width: 100%;\r\n}\r\n\r\n.gestion-comptes h1 {\r\n  margin-bottom: 3rem;\r\n}\r\n\r\n/* Style spécifique pour assurer que le menu d'actions est correctement positionné */\r\n.action-menu-container {\r\n  position: relative;\r\n  display: inline-block;\r\n}\r\n\r\n.action-options-menu {\r\n  position: absolute;\r\n  top: 100%;\r\n  right: 0;\r\n  background: white;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n  min-width: 220px;\r\n  z-index: 1000;\r\n  padding: 5px 0;\r\n  margin-top: 5px;\r\n}\r\n\r\n.user-name,\r\n.user-email,\r\n.commande-count,\r\n.commande-value,\r\n.user-role,\r\n.creation-date {\r\n  font-size: 1.4rem;\r\n  color: #2c3948;\r\n}\r\n\r\n.user-role {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.8rem;\r\n  color: #2c3948;\r\n  cursor: pointer;\r\n}\r\n\r\n.user-role span {\r\n  text-decoration: underline;\r\n}\r\n\r\n.user-role .edit-icon {\r\n  width: 1.6rem;\r\n  height: 1.6rem;\r\n  color: #f97316;\r\n}\r\n\r\n.user-role:hover span {\r\n  color: #f97316;\r\n}\r\n\r\n.user-role:hover .edit-icon {\r\n  color: #c4631f;\r\n}\r\n\r\n/* Style pour la colonne Type */\r\n.type-cell {\r\n  font-size: 1.4rem;\r\n  color: #2c3948;\r\n}\r\n\r\n.gestion-comptes-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 24px;\r\n}\r\n\r\n/* Styles pour le modal de changement de rôle */\r\n.modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.change-role-modal {\r\n  background-color: #fffdfc;\r\n  /* padding: 2rem; */\r\n  border-radius: 0.8rem;\r\n  min-width: 40rem;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.change-role-modal h2 {\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.change-role-modal p {\r\n  margin-bottom: 2rem;\r\n  color: #6b7280;\r\n}\r\n\r\n.role-options {\r\n  display: flex;\r\n  gap: 1rem;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.role-button {\r\n  padding: 0.8rem 1.6rem;\r\n  border-radius: 0.4rem;\r\n  border: 1px solid #e5e7eb;\r\n  background-color: #fffdfc;\r\n  cursor: pointer;\r\n  font-size: 1.4rem;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.role-button:hover {\r\n  background-color: #f9fafb;\r\n}\r\n\r\n.role-button.active {\r\n  background-color: rgba(215, 217, 217, 0.2);\r\n  border-color: #dbeafe;\r\n  color: #484848;\r\n}\r\n\r\n.role-button.selected {\r\n  background-color: #fcf1e7;\r\n  border-color: #f97316;\r\n  color: #f97316;\r\n  box-shadow: 0 0 0 1px #f97316;\r\n}\r\n\r\n.role-button:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.modal-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n}\r\n\r\n/* Style pour l'info-bulle du bouton \"Créer un utilisateur\" */\r\n.button-with-tooltip[title]:hover::after {\r\n  content: attr(title);\r\n  position: absolute;\r\n  bottom: 100%;\r\n  right: 0;\r\n  background-color: #2c3948;\r\n  color: white;\r\n  padding: 0.8rem 1.2rem;\r\n  border-radius: 0.4rem;\r\n  font-size: 1.2rem;\r\n  white-space: nowrap;\r\n  z-index: 1000;\r\n  margin-bottom: 0.5rem;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\r\n  max-width: 30rem;\r\n  white-space: normal;\r\n  text-align: center;\r\n}\r\n\r\n.button-with-tooltip[title]:hover::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  bottom: 100%;\r\n  right: 2rem;\r\n  border: 0.5rem solid transparent;\r\n  border-top-color: #2c3948;\r\n  margin-bottom: -0.5rem;\r\n}\r\n\r\n/* Styles pour les colonnes de lots techniques et départements */\r\n.lots-techniques,\r\n.lots-departements {\r\n  font-size: 1.3rem;\r\n  line-height: 1.6;\r\n  color: #2c3948;\r\n}\r\n\r\n.lots-techniques span,\r\n.lots-departements span {\r\n  display: block;\r\n  margin: 0.2rem 0;\r\n}\r\n\r\n.no-lot {\r\n  color: #9ca3af;\r\n  font-style: italic;\r\n}\r\n\r\n/* Styles pour la modal de réattribution */\r\n.modal-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 2rem 2rem 1rem 2rem;\r\n  border-bottom: 1px solid #e5e7eb;\r\n}\r\n\r\n.modal-header h2 {\r\n  margin: 0;\r\n  font-size: 1.8rem;\r\n  color: #2c3948;\r\n}\r\n\r\n.close-button {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  padding: 0.5rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: #6b7280;\r\n  transition: color 0.2s ease;\r\n}\r\n\r\n.close-button:hover {\r\n  color: #f97316;\r\n}\r\n\r\n.close-button svg {\r\n  width: 2rem;\r\n  height: 2rem;\r\n}\r\n\r\n.modal-body {\r\n  padding: 2rem;\r\n}\r\n\r\n.info-section {\r\n  background-color: rgba(194, 194, 194, 0.46);\r\n  border-radius: 0.6rem;\r\n  padding: 1.5rem;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.info-row {\r\n  display: flex;\r\n  padding: 0.5rem 0;\r\n}\r\n\r\n.info-row:not(:last-child) {\r\n  border-bottom: 1px solid #e5e7eb;\r\n}\r\n\r\n.info-label {\r\n  font-weight: 600;\r\n  color: #6b7280;\r\n  min-width: 180px;\r\n  font-size: 1.4rem;\r\n}\r\n\r\n.info-value {\r\n  color: #2c3948;\r\n  font-size: 1.4rem;\r\n}\r\n\r\n.form-group-modal {\r\n  margin-top: 1.5rem;\r\n}\r\n\r\n.form-group-modal label {\r\n  display: block;\r\n  margin-bottom: 0.8rem;\r\n  font-weight: 600;\r\n  color: #2c3948;\r\n  font-size: 1.4rem;\r\n}\r\n\r\n.form-select {\r\n  width: 100%;\r\n  padding: 1rem;\r\n  border-radius: 0.6rem;\r\n  border: 1px solid #d1d5db;\r\n  font-size: 1.4rem;\r\n  color: #2c3948;\r\n  background-color: white;\r\n  cursor: pointer;\r\n  transition: border-color 0.2s ease;\r\n}\r\n\r\n.form-select:hover {\r\n  border-color: #f97316;\r\n}\r\n\r\n.form-select:focus {\r\n  outline: none;\r\n  border-color: #f97316;\r\n  box-shadow: 0 0 0 3px rgba(218, 112, 39, 0.1);\r\n}\r\n\r\n.modal-actions {\r\n  padding: 1rem 2rem 2rem 2rem;\r\n  border-top: 1px solid #e5e7eb;\r\n}\r\n\r\n.actions-cell {\r\n  display: flex;\r\n  gap: 0.5rem;\r\n  align-items: center;\r\n}\r\n\r\n.modal-container {\r\n  background-color: #fff;\r\n  border-radius: 8px;\r\n  max-width: 600px;\r\n  width: 90%;\r\n}\r\n\r\n/* ═══════════════════════════════════════════════════════\r\n   Cartes membres acheteurs — style identique aux membres prestataires\r\n   Basculer ACHETEURS_VIEW_MODE 'cards' | 'table' dans GestionComptes.tsx\r\n   ═══════════════════════════════════════════════════════ */\r\n\r\n/* ── Grille ── */\r\n.gc-membres-cards-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, 1fr);\r\n  gap: 1.4rem;\r\n  padding: 0.5rem 0 1rem;\r\n}\r\n\r\n@media (min-width: 1600px) {\r\n  .gc-membres-cards-grid {\r\n    grid-template-columns: repeat(6, 1fr);\r\n  }\r\n}\r\n\r\n@media (max-width: 1100px) {\r\n  .gc-membres-cards-grid {\r\n    grid-template-columns: repeat(3, 1fr);\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .gc-membres-cards-grid {\r\n    grid-template-columns: repeat(2, 1fr);\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .gc-membres-cards-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n.gc-membres-cards-empty {\r\n  color: #9ca3af;\r\n  font-style: italic;\r\n  font-size: 1.3rem;\r\n  padding: 2rem 0;\r\n  text-align: center;\r\n}\r\n\r\n/* ── Carte ── */\r\n.gc-membre-card {\r\n  background: #fff;\r\n  border-radius: 12px;\r\n  overflow: visible;\r\n  position: relative;\r\n  min-width: 0;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\r\n  display: flex;\r\n  flex-direction: column;\r\n  transition:\r\n    box-shadow 0.2s,\r\n    transform 0.2s;\r\n  cursor: default;\r\n}\r\n\r\n.gc-membre-card--editable {\r\n  cursor: pointer;\r\n}\r\n\r\n.gc-membre-card--editable:hover {\r\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.14);\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.gc-membre-card-inner {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  border-radius: inherit;\r\n  overflow: hidden;\r\n  position: relative;\r\n}\r\n\r\n/* ── Bandeau gris ── */\r\n.gc-membre-card-header {\r\n  height: 72px;\r\n  border-radius: 12px 12px 0 0;\r\n  position: relative;\r\n  overflow: visible;\r\n}\r\n\r\n.gc-membre-card-banner {\r\n  width: 100%;\r\n  height: 72px;\r\n  background: #e5e7eb;\r\n  border-radius: 12px 12px 0 0;\r\n}\r\n\r\n/* ── Badge rôle top-right ── */\r\n.gc-membre-card-role-badge {\r\n  position: absolute;\r\n  top: 0.5rem;\r\n  right: 0.5rem;\r\n  padding: 0.25rem 0.6rem;\r\n  border-radius: 20px;\r\n  font-size: 1rem;\r\n  font-weight: 700;\r\n  background: rgba(107, 114, 128, 0.88);\r\n  color: #fff;\r\n  z-index: 2;\r\n  white-space: nowrap;\r\n  max-width: calc(100% - 1rem);\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.18);\r\n}\r\n\r\n.gc-membre-card-role-badge--admin {\r\n  background: #f97316;\r\n  box-shadow: 0 1px 4px rgba(249, 115, 22, 0.35);\r\n}\r\n\r\n/* Couleurs alignees sur l'annuaire : signataires/admin = orange (titulaire),\r\n   simples = gris (prestataire libre). Bandeau + pastille. Ombre SOMBRE (comme l'annuaire)\r\n   pour que la pastille ne se fonde pas dans un bandeau de la meme couleur. */\r\n.gc-membre-card--titulaire .gc-membre-card-banner {\r\n  background: #f97316;\r\n}\r\n.gc-membre-card--titulaire .gc-membre-card-role-badge {\r\n  background: #f97316;\r\n  color: #fff;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);\r\n}\r\n.gc-membre-card--libre .gc-membre-card-banner {\r\n  background: #d1d5db;\r\n}\r\n.gc-membre-card--libre .gc-membre-card-role-badge {\r\n  background: #d1d5db;\r\n  color: #374151;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);\r\n}\r\n\r\n/* ── Avatar rond chevauchant le bandeau ── */\r\n.gc-membre-card-avatar-wrapper {\r\n  position: absolute;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  top: 30px;\r\n  width: 64px;\r\n  height: 64px;\r\n  background: #fff;\r\n  border-radius: 50%;\r\n  border: 1.5px solid #d1d5db;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n  z-index: 1;\r\n  overflow: hidden;\r\n}\r\n\r\n.gc-membre-card-avatar {\r\n  width: 100%;\r\n  height: 100%;\r\n  background: #f3f4f6;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 1.6rem;\r\n  font-weight: 700;\r\n  color: #6b7280;\r\n  letter-spacing: 0.05em;\r\n}\r\n\r\n/* ── Corps ── */\r\n.gc-membre-card-body {\r\n  padding: 4rem 1.2rem 1.4rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 0.2rem;\r\n  flex: 1;\r\n  text-align: center;\r\n}\r\n\r\n.gc-membre-card-name {\r\n  font-weight: 700;\r\n  font-size: 1.35rem;\r\n  color: #111827;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  width: 100%;\r\n  margin: 0;\r\n}\r\n\r\n.gc-membre-card-fonction {\r\n  font-size: 1.25rem;\r\n  color: #374151;\r\n  font-style: normal;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  width: 100%;\r\n  margin: 0;\r\n}\r\n\r\n/* ── Contacts ── */\r\n.gc-membre-card-contacts {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 0.1rem;\r\n  margin-top: 0.5rem;\r\n  width: 100%;\r\n}\r\n\r\n.gc-membre-card-contact {\r\n  font-size: 1.2rem;\r\n  color: #6b7280;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  max-width: 100%;\r\n  display: block;\r\n}\r\n\r\n.gc-membre-card-email {\r\n  font-size: 1.2rem;\r\n}\r\n\r\n.gc-membre-card-hint {\r\n  font-size: 1.05rem;\r\n  color: #9ca3af;\r\n  font-style: italic;\r\n  margin: 0.6rem 0 0;\r\n  text-align: center;\r\n}\r\n\r\n/* ── Footer date + MDP ── */\r\n.gc-membre-card-footer {\r\n  border-top: 1px solid #f3f4f6;\r\n  padding: 0.65rem 1rem;\r\n  min-height: 4rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.gc-membre-card-date {\r\n  font-size: 1rem;\r\n  color: #9ca3af;\r\n  font-style: italic;\r\n}\r\n\r\n.gc-membre-card-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.4rem;\r\n  padding: 0.35rem 1rem;\r\n  border-radius: 20px;\r\n  border: 1px solid #e5e7eb;\r\n  background: #f9fafb;\r\n  color: #6b7280;\r\n  font-size: 1.1rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition:\r\n    background 0.15s,\r\n    border-color 0.15s;\r\n}\r\n\r\n.gc-membre-card-btn:hover {\r\n  background: #f3f4f6;\r\n  border-color: #d1d5db;\r\n}\r\n\r\n.gc-membre-card-btn svg {\r\n  width: 13px;\r\n  height: 13px;\r\n}\r\n\r\n/* ── Skeleton ── */\r\n@keyframes gc-membre-shimmer {\r\n  0% {\r\n    background-position: -200% 0;\r\n  }\r\n  100% {\r\n    background-position: 200% 0;\r\n  }\r\n}\r\n\r\n.gc-membre-card-skeleton {\r\n  pointer-events: none;\r\n}\r\n\r\n.gc-membre-card-skeleton .sk {\r\n  background: linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 50%, #e5e7eb 75%);\r\n  background-size: 200% 100%;\r\n  animation: gc-membre-shimmer 1.4s ease-in-out infinite;\r\n  border-radius: 4px;\r\n  display: block;\r\n}\r\n\r\n.gc-membre-card-skeleton .sk-banner {\r\n  border-radius: 12px 12px 0 0;\r\n  height: 72px;\r\n}\r\n\r\n.gc-membre-card-skeleton .sk-badge {\r\n  position: absolute;\r\n  top: 0.5rem;\r\n  right: 0.5rem;\r\n  width: 70px;\r\n  height: 18px;\r\n  border-radius: 20px;\r\n  z-index: 2;\r\n  background: linear-gradient(90deg, #d1d5db 25%, #e5e7eb 50%, #d1d5db 75%);\r\n  background-size: 200% 100%;\r\n  animation: gc-membre-shimmer 1.4s ease-in-out infinite;\r\n  display: block;\r\n}\r\n\r\n.gc-membre-card-skeleton .sk-avatar {\r\n  width: 64px;\r\n  height: 64px;\r\n  border-radius: 50%;\r\n}\r\n\r\n.gc-membre-card-skeleton .sk-line {\r\n  height: 11px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.gc-membre-card-skeleton .sk-line--name {\r\n  width: 72%;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.gc-membre-card-skeleton .sk-line--fonction {\r\n  width: 52%;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.gc-membre-card-skeleton .sk-line--contact {\r\n  width: 85%;\r\n  margin-bottom: 3px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
